import { merge } from "../core/Merge.js";
import { Signal } from "../core/Signal.js";
import { Actor, ActorNonOptions } from "./Actor.js";

export type SwipeDirection = "left" | "right" | "up" | "down";

export interface SwipeOptions {
    minDistance?: number;
    maxLifetime?: number;
    actor?: Actor;
    element?: HTMLElement;
    onSwipe?: (direction: SwipeDirection, swipe: Swipe) => void;
}

export class Swipe {
    public static DEFAULT: SwipeOptions = {
        minDistance: 20,
        maxLifetime: 600,
    };

    public onSwipe = Signal.create<[SwipeDirection, Swipe]>();

    public minDistance: number;
    public maxLifetime: number;
    private _direction: SwipeDirection = "left";
    private _actor: Actor;

    constructor(options: SwipeOptions = null) {
        this._actor =
            options?.actor ||
            (options?.element ? new Actor(options?.element) : null);

        if (!this._actor) {
            console.error(
                "Swipe: No actor or element provided for swipe detection."
            );
            return;
        }

        if (options?.onSwipe) {
            this.onSwipe.add(options.onSwipe);
        }

        if (options !== ActorNonOptions) this.setOptions(options);

        this._actor.onUp.add((pointers) => {
            if (this._actor.count !== 0 || this._actor.pointer.multitouch)
                return;

            var lifeTime = Actor.lifetime(pointers);
            var pointer = pointers[0];
            if (
                pointer.distance >= this.minDistance &&
                lifeTime <= this.maxLifetime
            ) {
                var direction: SwipeDirection = "left";
                if (Math.abs(pointer.moveX) > Math.abs(pointer.moveY)) {
                    direction =
                        pointer.x - pointer.originX > 0 ? "right" : "left";
                } else {
                    direction = pointer.y - pointer.originY > 0 ? "down" : "up";
                }
                this._direction = direction;
                this.onSwipe.dispatch(direction, this);
            }
        });
    }

    public get direction(): SwipeDirection {
        return this._direction;
    }

    public setOptions(options: SwipeOptions) {
        options = merge({}, Swipe.DEFAULT, options);
        this.minDistance = options.minDistance;
        this.maxLifetime = options.maxLifetime;
    }
}
